import axios from 'axios';
import { CONFIG } from '@/config/Config';
import { addSessionId } from '@/core/utils/httpHeaders';
import {
  AnnotationHistoryResponse,
  AnnotationHistoryParams,
} from './interfaces/AnnotationHistoryInterfaces';
import { getAccountId, getUniId, getUserId } from '@/core/utils/extractCookieId';

const SERVICE_NAME = 'annotations-history';

const getTodayTimestamp = (time: '0000' | '2359'): string => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}${month}${day}${time}`;
};

class AnnotationHistoryService {
  async getFilterAndBulkAnnotations(
    params: Partial<AnnotationHistoryParams> = {}
  ): Promise<AnnotationHistoryResponse> {
    const accId = getAccountId();
    const uniId = getUniId();
    const usrId = getUserId();

    // Account, universe and user IDs are always derived from cookies — intentionally.
    // The request must reflect the currently authenticated session; accepting these
    // values as params would allow callers to query data for arbitrary identities,
    // which is not a supported or safe use-case for this service.

    if (!accId || !uniId || !usrId) {
      return { annotations: [] };
    }

    const {
      startingAt = getTodayTimestamp('0000'),
      endingAt = getTodayTimestamp('2359'),
      type = ['annotate_filter_bulk_post'],
    } = params;

    const baseUrl = CONFIG.getServiceUrl(SERVICE_NAME);
    const url = `${baseUrl}/account/${accId}/universe/${uniId}/userId/${usrId}/annotations`;
    const headers = addSessionId({ accept: 'application/json' });

    const response = await axios.get<AnnotationHistoryResponse>(url, {
      headers,
      params: { type, startingAt, endingAt },
      paramsSerializer: { indexes: null }
    });

    return {
      annotations: response.data.annotations ?? [],
    };
  }
}

const annotationHistoryService = new AnnotationHistoryService();
export default annotationHistoryService;